import { render, staticRenderFns } from "./my-favorite.vue?vue&type=template&id=b342ab20&scoped=true"
import script from "./my-favorite.vue?vue&type=script&lang=ts"
export * from "./my-favorite.vue?vue&type=script&lang=ts"
import style0 from "./my-favorite.vue?vue&type=style&index=0&id=b342ab20&prod&scoped=true&lang=scss"
import style1 from "./my-favorite.vue?vue&type=style&index=1&id=b342ab20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b342ab20",
  null
  
)

export default component.exports